import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AdBanner from './AdBanner';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* Top Ad Banner */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AdBanner size="leaderboard" className="mx-auto" />
        </div>
      </div>

      <div className="flex-1 flex">
        {/* Sidebar Ad (Desktop only) */}
        <div className="hidden xl:block w-80 bg-gray-50 p-6">
          <div className="sticky top-6">
            <AdBanner size="skyscraper" />
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-1">
          <Outlet />
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Layout;